import { render } from "./OrganisationInvite.vue?vue&type=template&id=7fbe680a"
import script from "./OrganisationInvite.vue?vue&type=script&lang=js"
export * from "./OrganisationInvite.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__